import React from 'react'
import constUserGroup from '../../../../../constants/userGroup'
import useLookupService from '../../../../../services/lookup/useLookupService'
import useWebService from '../../../../../services/web/useWebService'
import * as syntheticFormTypes from './synthesisType'
import checkPermission from '../../../../../utilities/checkPermission'
import useLoading from '../../../../../control/loading/useLoading'
import useAppFolderAndTabAction from '../../../../../stores/appFolderAndTab/appFolderAndTabAction'
import useTranslate from '../../../../../i18n/useTranslate'
import useManageProjectStore from '../../../../../stores/manageProject/useManageProjectStore'
import authenStore from '../../../../../stores/authen/authenStore'
import * as REQServiceType from '../../../../../services/web/types/requestWebServiceTypes'

import _ from 'lodash'
import { DialogType } from '../../../../../control/dialog/dialog'
import { requestWebServiceTypes } from '../../../../../services/web/types'
import { RoutePath } from '../../../../../router/routesConfig'
import { useHistory } from 'react-router-dom'
import useFolderAndTab from '../../useFolderAndTab'
import { TabSelectedType } from '../../../../../stores/appFolderAndTab/appFolderAndTabStore'
import { DatasourceForCopyToClipbaord } from '../../../../../control/copyToClipboard/copyToclipboard'
import submittedStep from '../../../../../constants/submittedStep'
import { convertDateToFormatTH } from '../../../../../utilities/date'
import useEditSynthesis from '../../../shareLogic/useEditSynthesis'
import { DatasourceForExport } from '../../../../../control/exportToMSWord/exportToMSWord'

const useSynthesis = (props: syntheticFormTypes.UseSynthetic) => {
    const { callbackSaveComplete, isOneComment } = props
    const manageProjectStore = useManageProjectStore()
    const tabAndFolderHook = useFolderAndTab()

    const projectData = manageProjectStore.projectData
    const [isExempt, setIsExempt] = React.useState<boolean>(false)
    const loadingHook = useLoading()
    const translate = useTranslate()
    const callLookup = useLookupService()
    const callWebService = useWebService()
    const [initialValues, setInitialValues] = React.useState<any>({})
    const [reviewer, setReviewer] = React.useState<syntheticFormTypes.OptType[]>([])
    const [commentTitleList, setCommentTitleList] = React.useState<syntheticFormTypes.ResultType[]>([])
    const [initialSynthesis, setInitialSynthesis] = React.useState<any>()
    const [synthesisProject, setSynthesisProject] = React.useState<any>()
    const [commentList, setCommentList] = React.useState<any[]>([])
    const [remarkList, setRemarkList] = React.useState<syntheticFormTypes.CommitteeCommentTopicInfo[]>([])
    const [isRequired, setIsRequired] = React.useState<boolean>(false)
    const [isEditSynthsisSuccess, setIsEditSynthesisSuccess] = React.useState<boolean>(false)
    const formRef = React.useRef<any>()
    const [textRemaining, setTextRemaining] = React.useState<number[]>([])
    const [textRemainingRemark, setTextRemainingRemark] = React.useState<number>()
    const defaultRemarkRef = React.useRef<string>()
    const checkPermissionHook = checkPermission()
    const isViewMode = checkPermissionHook.chkProjectStepViewMode(projectData)
    const isShowUpdateDate = checkPermissionHook.chkShowUpdateDate(projectData)
    const appFolderAndTabAction = useAppFolderAndTabAction()
    const profileStore = authenStore()
    const { profile } = profileStore
    const [configDialog, setConfigDialog] =
        React.useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const dialogRef = React.useRef<Record<string, Function>>()
    const history = useHistory()
    const formValues = React.useRef<syntheticFormTypes.TFormValue>()

    const [dataSourceForCopyToClipboard, setDataSourceForCopyToClipboard] = React.useState<
        DatasourceForCopyToClipbaord[]
    >([])
    const [dataSourceForExport, setDataSourceForExport] = React.useState<DatasourceForExport[]>([])
    const editSynthesis = useEditSynthesis({ form: formRef.current, setIsEditSynthesisSuccess })

    const onRefDialog = (func: Record<string, Function>) => {
        //ห้าม set State หรือเรียก Action ในนี้
        dialogRef.current = func
    }
    React.useEffect(() => {
        if (projectData) {
            //check ประเภทพโครงการ กรณีเป็นโครงการประเภท excempt ถ้าเป็น excempt แสดงแบบกล่องเดียว

            if (isOneComment) {
                setIsExempt(true)
            } else {
                setIsExempt(false)
            }
            if (projectData?.irb) {
                getReviewer(projectData.irb)
            }

            getCommentaryTopicLut(projectData?.irb)
        }

        getSynthesisProjectByID()
        getAllCommentaryForExport()
    }, [
        projectData?.projectID ?? null,
        projectData?.submittedID ?? null,
        translate.languageStore.currentLanguage,
        isEditSynthsisSuccess,
    ])

    React.useEffect(() => {
        createInitialSynthesis()
    }, [commentTitleList, synthesisProject])

    const getReviewer = async (irb: number) => {
        if (irb) {
            const res = await callLookup.callReviewerLut(irb)
            const formatData = res.result.map((itm) => {
                return {
                    label:
                        translate.languageStore.currentLanguage === translate.languageKey.th
                            ? itm.name_th
                            : itm.name_en,
                    value: `${itm.id}`,
                }
            })
            setReviewer(formatData)
        }
    }

    const getCommentaryTopicLut = async (irb: number) => {
        if (irb) {
            const res = await callLookup.callCommentaryTopicLut(irb)
            if (res.result) {
                const formatData = res.result.map((itm: any, index: number) => {
                    return { ...itm, no: index + 1 }
                })
                setCommentTitleList(formatData)
            }
        }
    }

    const getSynthesisProjectByID = async () => {
        if (projectData) {
            loadingHook.loadingOpen()
            const { result } = await callWebService.getSynthesisProjectByID(projectData.submittedID)
            const dataForCopyToClipboard = [
                {
                    fullNameTH: result.fullReviewer_th ? result.fullReviewer_th : ' ',
                    fullNameEN: result.fullReviewer_en ? result.fullReviewer_en : ' ',
                    updatedDate: convertDateToFormatTH(result.updatedDate),
                    updateByNameTH: result.updatedByNameTH,
                    updateByNameEN: result.updatedByNameEN,
                    approveStatusNameTH: result.approveStatusName_th ?? '',
                    approveStatusNameEN: result.approveStatusName_en ?? '',
                    commentaryInfo: result.synthesisInfo.map((itm) => {
                        return {
                            topicID: itm.topicID,
                            no: itm.no,
                            comment: itm.comment.contentText,
                            comment_htmltag: itm.comment?.contentHtml
                                ? itm.comment?.contentHtml
                                      .replaceAll('<ins>', '<u>')
                                      .replaceAll('</ins>', '</u>')
                                      .replaceAll('<del>', '<s>')
                                      .replaceAll('</del>', '</s>')
                                : itm.comment?.contentHtml,
                            name_th:
                                profile.irb === 1 && itm.topicName_th_irb1
                                    ? itm.topicName_th_irb1
                                    : profile.irb === 2 && itm.topicName_th_irb2
                                    ? itm.topicName_th_irb2
                                    : 'ข้อคิดเห็น / ข้อสังเกต',
                            name_en:
                                profile.irb === 1 && itm.topicName_en_irb1
                                    ? itm.topicName_en_irb1
                                    : profile.irb === 2 && itm.topicName_en_irb2
                                    ? itm.topicName_en_irb2
                                    : 'ข้อคิดเห็น / ข้อสังเกต',
                        }
                    }),
                },
            ]
            setDataSourceForCopyToClipboard(dataForCopyToClipboard)

            loadingHook.loadingClose()
            setSynthesisProject(result)
        }
    }

    const createInitialData = () => {
        const conditionRemark =
            synthesisProject && synthesisProject?.synthesisRemarkInfo && synthesisProject?.synthesisRemarkInfo?.remark

        const remark = synthesisProject?.synthesisRemarkInfo?.remark
        const countStrRemark = remark ? remark.length : 0
        const textRemainingRemarkInitial = 4000 - countStrRemark

        const initialData = {
            reviewer:
                projectData && projectData.reviewerName_th
                    ? { label: projectData.reviewerName_th, value: projectData.reviewerUserID.toString() }
                    : {},
            approveStatus:
                synthesisProject && synthesisProject?.approveStatusID
                    ? {
                          label: synthesisProject.approveStatusName_th,
                          value: synthesisProject?.approveStatusID.toString(),
                      }
                    : null,
            submittedID: synthesisProject && synthesisProject?.submittedID ? synthesisProject?.submittedID : null,
            remark: conditionRemark ? synthesisProject?.synthesisRemarkInfo?.remark : isViewMode ? '-' : null,
            progress_6_months: synthesisProject?.progress_6_months,
            progress_12_months: synthesisProject?.progress_12_months,
        }
        setTextRemainingRemark(textRemainingRemarkInitial)
        setInitialValues(initialData)
    }

    const createInitialSynthesis = () => {
        setInitialSynthesisInfo()
        setInitialRemarkSynthesisInfo()

        createInitialData()
    }
    const setInitialSynthesisInfo = () => {
        if (projectData && synthesisProject) {
            if (
                synthesisProject?.synthesisInfo.length > 1
                // projectData.submitTypeInfo.value !== constSubmittedType.editAfterReview //เช็คว่าต้องไม่ใช่โครงการที่เป็น แก้ไขหลังพิจารณา
            ) {
                setInitialSubComment() //เป็นหัวข้อ
            } else {
                setInitialComment() //เป็นแบบข้อเดียว
            }
        }
    }

    const setInitialSubComment = () => {
        const synthesisInit = commentTitleList?.map((itm: any) => {
            return {
                topic: translate.languageStore.currentLanguage === translate.languageKey.th ? itm.name_th : itm.name_en,
                id: itm.id,
                synthesisList: { contentHtml: '', contentText: '' },
                commentList: null,
                strTheRest: 4000,
            }
        })
        synthesisInit.forEach((item: any) => {
            synthesisProject?.synthesisInfo.forEach((info: syntheticFormTypes.synthesisProjectType) => {
                if (info.topicID === item.id) {
                    item.topic =
                        translate.languageStore.currentLanguage === translate.languageKey.th
                            ? info.topicName_th
                            : info.topicName_en
                    item.id = info.topicID
                    let defaultTextSynthesisList = ''
                    let defaultHTMLSynthesisList = ''

                    //จัดความคิดเห็นของกรรมการ
                    const objComment = info.committeeCommentTopicInfo.map((itm: any, index) => {
                        // //เอาคอมเม้นของกรรมการทุกคนมายำรวมกัน ขึ้นบรรทัดใหม่เมื่อเป็นอาจารย์คนถัดไป
                        defaultTextSynthesisList =
                            index === 0
                                ? `${itm.comment?.contentText}`
                                : `${defaultTextSynthesisList}\n${itm.comment?.contentText}`
                        defaultHTMLSynthesisList =
                            index === 0
                                ? `${itm.comment?.contentHtml}`
                                : `${defaultHTMLSynthesisList}\n${itm.comment?.contentHtml}`

                        return {
                            no: info.no,
                            topicID: info.topicID,
                            director:
                                translate.languageStore.currentLanguage === translate.languageKey.th
                                    ? itm.fullName_th
                                    : itm.fullName_en,
                            comment: { contentText: itm.comment.contentText, contentHtml: itm.comment.contentHtml },
                            approveStatusName:
                                translate.languageStore.currentLanguage === translate.languageKey.th
                                    ? itm.approveStatusName_th
                                    : itm.approveStatusName_en,
                            saveCommentDate: itm.saveCommentDate,
                        }
                    })
                    item.commentList = objComment
                    item.synthesisList.contentText = info.comment?.contentText
                        ? info.comment?.contentText
                        : defaultTextSynthesisList
                    item.synthesisList.contentHtml = info.comment?.contentHtml
                        ? info.comment?.contentHtml
                        : defaultHTMLSynthesisList
                    const countTextComment = info.comment.contentText ? info.comment.contentText?.length : 0
                    item.strTheRest = 4000 - countTextComment
                }
            })
        })

        const commentDirector = synthesisInit.map((itm) => {
            return itm.commentList
        })

        const textRemain = synthesisInit?.map((item) => {
            return item.strTheRest
        })
        setTextRemaining(textRemain)

        setCommentList(commentDirector)
        setInitialSynthesis(synthesisInit)
    }
    const setInitialComment = () => {
        const synthesisInit = [
            {
                topic: 'โครงการวิจัย',
                id: 1,
                synthesisList: { contentHtml: '', contentText: '' },
                commentList: null,
                strTheRest: 4000,
            },
        ]
        synthesisInit.forEach((item: any) => {
            synthesisProject?.synthesisInfo.forEach((info: syntheticFormTypes.synthesisProjectType) => {
                item.synthesisList = info.comment
                item.topic =
                    translate.languageStore.currentLanguage === translate.languageKey.th
                        ? info.topicName_th
                        : info.topicName_en
                item.id = info.topicID

                let defaultTextSynthesisList = ''
                let defaultHTMLSynthesisList = ''

                //จัดความคิดเห็นของกรรมการ
                const objComment = info.committeeCommentTopicInfo.map((itm: any, index) => {
                    // //เอาคอมเม้นของกรรมการทุกคนมายำรวมกัน ขึ้นบรรทัดใหม่เมื่อเป็นอาจารย์คนถัดไป
                    defaultTextSynthesisList =
                        index === 0
                            ? `${itm.comment?.contentText}`
                            : `${defaultTextSynthesisList}\n${itm.comment?.contentText}`
                    defaultHTMLSynthesisList =
                        index === 0
                            ? `${itm.comment?.contentHtml}`
                            : `${defaultHTMLSynthesisList}\n${itm.comment?.contentHtml}`
                    return {
                        no: info.no,
                        topicID: info.topicID,
                        director:
                            translate.languageStore.currentLanguage === translate.languageKey.th
                                ? itm.fullName_th
                                : itm.fullName_en,
                        comment: { contentText: itm.comment.contentText, contentHtml: itm.comment.contentHtml },
                        approveStatusName:
                            translate.languageStore.currentLanguage === translate.languageKey.th
                                ? itm.approveStatusName_th
                                : itm.approveStatusName_en,
                        saveCommentDate: itm.saveCommentDate,
                    }
                })
                item.commentList = objComment
                item.synthesisList.contentText = info.comment?.contentText
                    ? info.comment?.contentText
                    : defaultTextSynthesisList
                item.synthesisList.contentHtml = info.comment?.contentHtml
                    ? info.comment?.contentHtml
                    : defaultHTMLSynthesisList
                const countTextComment = info.comment.contentText ? info.comment.contentText?.length : 0
                item.strTheRest = 4000 - countTextComment
            })
        })
        const commentDirector = synthesisInit.map((itm: any) => {
            return itm.commentList
        })

        const textRemain = synthesisInit?.map((item) => {
            return item.strTheRest
        })
        setTextRemaining(textRemain)
        setCommentList(commentDirector)
        setInitialSynthesis(synthesisInit)
    }

    const setInitialRemarkSynthesisInfo = () => {
        const remarkList = synthesisProject?.synthesisRemarkInfo?.committeeRemarkInfo
        remarkList?.forEach((element: syntheticFormTypes.CommitteeCommentTopicInfo, idx: number) => {
            defaultRemarkRef.current =
                idx === 0 ? `${element.comment}` : `${defaultRemarkRef.current}\n${element.comment}`
        })
        setRemarkList(remarkList)
    }
    /* function สำหรับ set ข้อมูลเมื่อเลือกผลพิจารณา */
    const handleChangStatus = (val: syntheticFormTypes.OptType) => {
        // if (val && val.value === '8') {
        //     setIsRequired(true)
        // } else {
        //     setIsRequired(false)
        // }
        // setTimeout(() => {
        //     formRef.current.resetFieldState('remark')
        // })
    }

    const handleDirtyChange = (props: any) => {
        formValues.current = { ...props.values }
        let isDirty: boolean = false
        //** จัดformat initValue และ Form Value เพื่อเตรียมตัวนำไปใช้เปรียบเทียบค่า  **//
        let newFormValue = _.omit({ ...props.values }, ['commentList1'])
        let initValue = _.omit({ ...initialValues, synthesisInfo: initialSynthesis }, ['commentList1'])

        //**********************************************************//
        const isEqual = _.isEqual(newFormValue, initValue) //ข้อมูลเท่ากัน

        if (!isViewMode) {
            if (isEqual) {
                isDirty = false
            } else {
                isDirty = true
            }
        }

        const paramsDirty = {
            tabDirty: isDirty,
            callbackDirty: callbackDirtyProcess,
        }
        appFolderAndTabAction.setDirty(paramsDirty)
    }

    const callbackDirtyProcess = (
        tabIndex: number | null = null,
        newTabSelected: TabSelectedType | null = null,
        isFolder?: boolean,
    ) => {
        const parameter = getParameterForSave(formValues.current)
        if (parameter) {
            parameter.isDraft = true
            handleConfirmSave(parameter, tabIndex, newTabSelected, isFolder)
        }
    }

    const handleChangTextField = (val: string, index: number) => {
        if (textRemaining?.length > 0) {
            textRemaining[index] = 4000 - val.length
        }
    }
    const handleChangRemark = (val: string) => {
        if (textRemainingRemark) {
            setTextRemainingRemark(4000 - val.length)
        }
    }
    const getParameterForSave = (val: syntheticFormTypes.TFormValue) => {
        let paramForSave = null
        const submittedID = manageProjectStore?.projectData?.submittedID ?? null

        let isDraft = false
        if (val.submitType === 'draft') {
            isDraft = true
        }
        const synthesisInfo = val?.synthesisInfo.map((item: any) => {
            return {
                topicID: item && item?.id ? item?.id : null,
                contentHtml: item && item?.synthesisList?.contentHtml ? item?.synthesisList?.contentHtml : null,
                contentText: item && item?.synthesisList?.contentText ? item?.synthesisList?.contentText : null,
            }
        })
        const synthesisProjectRequest: REQServiceType.SynthesisProjectType = {
            loginUserID: profileStore.profile.userId,
            submittedID: submittedID,
            reviewerID:
                profile.userGroupId === constUserGroup.officer
                    ? val && val.reviewer && val.reviewer.value
                        ? parseInt(val?.reviewer.value)
                        : null
                    : profileStore.profile.userId,
            approveStatusID:
                val && val.approveStatus && val.approveStatus.value ? parseInt(val?.approveStatus.value) : null,
            synthesisInfo: synthesisInfo ? synthesisInfo : [],
            synthesisRemark: val && val.remark ? val?.remark : null,
            isDraft: isDraft,
            progress_6_months: val.progress_6_months,
            progress_12_months: val.progress_12_months,
        }
        paramForSave = synthesisProjectRequest

        return paramForSave
    }
    const handleSubmitForm = async (val: syntheticFormTypes.TFormValue) => {
        const parameter = getParameterForSave(val)
        if (val.submitType === 'save') {
            setConfigDialog({
                title: translate.get('ALERT.TITLE.NOTIFICATION'),
                content: translate.get('ALERT.CONTENT.NEED_TO_SAVE'),
                type: 'alert-confirm',
                onClickConfirm: () => {
                    handleConfirmSave(parameter)
                },
            })
            dialogRef.current?.openDialog()
        } else {
            //ถ้า save draft ไม่ต้องมี alert confirm
            handleConfirmSave(parameter)
        }
    }

    const handleConfirmSave = async (
        paramForSave: requestWebServiceTypes.SynthesisProjectType,
        tabIndex: number | null = null,
        newTabSelected: TabSelectedType | null = null,
        isFolder?: boolean,
    ) => {
        dialogRef.current?.closeDialog()

        const isDraft = paramForSave.isDraft ? paramForSave.isDraft : false
        const isAutoSave = !!(paramForSave as any)?.isAutoSave
        loadingHook.loadingOpen()
        const res = await callWebService.synthesisProject(paramForSave)

        if (!isFolder) {
            //if นี้จะเช็คว่าเป็นการติด dirty จากการกดเปลี่ยน folder ใช่หรือไม่?
            if (tabIndex && newTabSelected) {
                //if นี้จะเช็คว่าเป็นการติด dirty จากการกดเปลี่ยน Tab ใช่หรือไม่?
                tabAndFolderHook.setTab(tabIndex, newTabSelected)
            } else {
                //หากเข้า else หมายความว่าเป็นการบันทึกจากกดปุ่มบันทึกไม่ใช่จากการติด dirty
                if (callbackSaveComplete && !isAutoSave) {
                    if (res && res.status) {
                        callbackSaveComplete(res.status, isDraft)
                    }
                }
            }
        }
        loadingHook.loadingClose()
    }

    const handleAutoSave = async (values: syntheticFormTypes.TFormValue) => {
        try {
            const isPassedSynthesis = (projectData?.stepID ?? 0) > submittedStep.synthesis
            if (isPassedSynthesis) return

            const paramForSave = getParameterForSave({ ...values, submitType: 'draft' })
            // check autosave
            const hasSynthesisContent = (paramForSave.synthesisInfo ?? []).some((item) =>
                Boolean(item.contentText?.trim() || item.contentHtml?.trim()),
            )
            const hasProgressValue = values.progress_6_months != null || values.progress_12_months != null
            if (!hasSynthesisContent && !paramForSave.synthesisRemark?.trim() && !hasProgressValue) return
            ;(paramForSave as any).isAutoSave = true
            //silent = true กัน dialog เด้งตอน autosave พลาด ผู้ใช้ไม่ได้กดบันทึกเอง
            await callWebService.synthesisProject(paramForSave, true)
        } catch (error) {
            console.error(error)
        }
    }

    const handleClickCancel = (dirty: boolean) => {
        if (dirty) {
            setConfigDialog({
                title: translate.get('ALERT.TITLE.WARNING'),
                content: translate.get('ALERT.CONTENT.NEED_TO_CANCEL'),
                type: 'alert-confirm',
                onClickConfirm: () => {
                    history.push(RoutePath.manageProject)
                },
            })
            dialogRef.current?.openDialog()
        } else {
            history.push(RoutePath.manageProject)
        }
    }
    const checkIsDisplayCopyToClipboard = () => {
        let isDisplayCopyToClipboard = false
        if (projectData) {
            if (projectData?.stepID > submittedStep.synthesis) {
                isDisplayCopyToClipboard = true
            } else {
                isDisplayCopyToClipboard = false
            }
        }
        return isDisplayCopyToClipboard
    }

    const editInitialSynthesis = (data: any) => {
        setInitialSynthesis(data)
    }

    const getAllCommentaryForExport = async () => {
        if (projectData) {
            const { result } = await callWebService.getHistorySynthesis(projectData?.submittedID)
            const allCommentList = result.map((itm) => {
                if (itm.commentary.length === 1) {
                    itm.commentary.forEach((comment) => {
                        comment.nameTopicTH1 = 'ข้อคิดเห็น / ข้อสังเกต'
                        comment.nameTopicEN1 = 'Suggestion / Notice'
                        comment.nameTopicTH2 = 'ข้อคิดเห็น / ข้อสังเกต'
                        comment.nameTopicEN2 = 'Suggestion / Notice'
                    })
                }

                return {
                    userID: itm.userID,
                    fullUsername_en: itm.fullUsername_en,
                    fullUsername_th: itm.fullUsername_th,
                    commentary: itm.commentary,
                    updatedDate: itm.updatedDate,
                    updateByNameTH: itm.updateByNameTH,
                    updateByNameEN: itm.updateByNameEN,
                    approveStatusName_th: itm.approveStatusName_th,
                    approveStatusName_en: itm.approveStatusName_en,
                    approveStatusID: itm.approveStatusID,
                    historyCommentary: itm.historyCommentary,
                }
            })
            setDataSourceForExport(allCommentList)
        }
    }
    return {
        commentList,
        isViewMode,
        initialValues,
        reviewerList: reviewer,
        commentTitleList,
        initialSynthesis,
        isExempt,
        remarkList,
        isRequired,
        formRef,
        configDialog,
        projectData,
        isShowUpdateDate,
        dataSourceForCopyToClipboard,
        isDisplayCopyToClipboard: checkIsDisplayCopyToClipboard(),
        useAccordionMode: editSynthesis.useAccordionMode,
        dataSourceForExport,
        defineValueFromInit: editSynthesis.defineValueFromInit,
        resetField: editSynthesis.resetField,
        confirmField: editSynthesis.confirmField,
        updateCommentary: editSynthesis.updateCommentary,
        editInitialSynthesis,
        onRefDialog,
        onChangTextField: handleChangTextField,
        handleDirtyChange,
        onChangStatus: handleChangStatus,
        onChangRemark: handleChangRemark,
        onSubmitForm: handleSubmitForm,
        onClickCancel: handleClickCancel,
        onAutoSave: handleAutoSave,
    }
}

export default useSynthesis
